import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SignDocumentTypes } from '../sign-document-types.enum';

@Component({
  selector: 'app-documents-sign-option',
  templateUrl: './documents-sign-option.component.html',
  styleUrls: ['./documents-sign-option.component.scss'],
})
export class DocumentsSignOptionComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() options = [];
  @Input() isButtonDisabled = false;
  @Input() isCompleted = false;
  @Output() optionSelectedEvent = new EventEmitter();
  @Output() drawerOpenedEvent = new EventEmitter();
  isDrawerOpened = false;
  isSubmitting = false;

  onOptionClick(): void {
    if (this.isCompleted) return;
    if (this.options.length) {
      this.isDrawerOpened = !this.isDrawerOpened;
      if (this.isDrawerOpened) {
        this.drawerOpenedEvent.emit(true);
      }
    } else {
      this.optionSelectedEvent.emit([SignDocumentTypes.DECLARACION_JURADA]);
    }
  }

  selectOption() {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    const selected = this.options.filter(o => o.value).map(o => o.selectedValue);
    this.optionSelectedEvent.emit(selected);
  }

  get isOptionsSelected() {
    const factoringOption = this.options?.find(item => item.selectedValue === SignDocumentTypes.FACTORING);
    const confirmingOption = this.options?.find(item => item.selectedValue === SignDocumentTypes.CONFIRMING);
    return factoringOption?.value || confirmingOption?.value;
  }
}
